import { render, staticRenderFns } from "./GeneralUpdate.vue?vue&type=template&id=669bd09f&"
import script from "./GeneralUpdate.vue?vue&type=script&lang=js&"
export * from "./GeneralUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports